module.exports = "https://la-static.vkplay.ru/promo/newstart/img/scout.c37d2c06.png";